import moment from 'moment';
import zxcvbn from 'zxcvbn';
import _ from 'lodash';

class ExpenseWizardController {

  constructor(CompanyService, toastr, $scope, $http, $rootScope, $stateParams, $state) {
    "ngInject";

    let self = this;

    this.moment = moment;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.state = $state;
    this.$stateParams = $stateParams;
    this.activeUsers = [];

    this.initializeData();

    this.wizard =  {
      show: function(number) {
        self.step = number;
      },
      next: function() {
        self.step++ ;
      },
      prev: function() {
        self.step-- ;
      }
    };

  }

  selectType(type) {
    switch (type) {
      case 'travel':
        this.state.go('travel-expense');
        break;
      case 'otherDirectCosts':
        this.state.go('other-direct-costs');
        break;
      case 'generalBusiness':
        this.state.go('general-business');
        break;
    }
  }

  getContracts() {
    if(this.customerFilter && this.customerFilter != 'none') {
      return this.customerFilter.contracts;
    }

    this.contractFilter = 'none';
    this.taskFilter = 'none';
    return undefined;
  }

  getProjects() {
    if(this.contractFilter && this.contractFilter != 'none') {
      return this.contractFilter.tasks;
    }

    this.taskFilter = 'none';
    return undefined;
  }

  getPops() {
    if(this.lcatFilter && this.lcatFilter != 'none') {
      return this.contractFilter.periodsOfPerformance;
    }

    this.popFilter = 'none';
    return undefined;
  }

  internalCodeFormValid() {
    if(this.chargecode.leaveType == 'false') {
      return true;
    } else {
      return this.chargecode.associatedLeaveType != 'none';
    }
  }

  projectFormValid(){
    let hasContract = this.contractFilter != 'none';
    let hasProject = this.taskFilter != 'none';
    let hasLcat = this.lcatFilter != 'none';
    let hasPop = this.popFilter != 'none';


    return hasContract && hasProject && hasLcat && hasPop;
  }

  setUse(use) {
    this.use = use;
    this.step++;
  }

  userHasChargeCode(userId) {
    let x = _.find(this.chargecode.users, {'id': userId} );
    return x ? true : false;
  }

  prepareProjectChargeCode() {
    this.chargecode.contract = { id: this.contractFilter.id };
    this.chargecode.lcat = this.lcatFilter;
    this.chargecode.taskOrder = this.taskFilter;
    this.chargecode.name = this.customerFilter.shortName + "-" + this.contractFilter.shortName + "-" + this.taskFilter.name + "-" + this.lcatFilter.shortName + "-" + this.popFilter.name;
    this.chargecode.leaveType = false;
    this.chargecode.billable = true;
    this.chargecode.periodOfPerformance = this.popFilter;

    this.checkForExistingChargeCodeName();

    this.step = 2;
  }

  prepareInternalChargeCode() {
    this.chargecode.leaveType = (this.chargecode.leaveType == 'true');

    if(!this.chargecode.leaveType) {
      this.chargecode.associatedLeaveType = null;
    }


    this.step = 2;
  }


  setLaborRate() {
    let self = this;
    let rate = 0;

    this.contractFilter.laborRates.forEach(function (laborRate) {
      let samePop = laborRate.periodOfPerformance.id == self.popFilter.id;
      let sameLcat = laborRate.laborCategory.id == self.lcatFilter.id;

      if(sameLcat && samePop) {
        rate = laborRate.rate;
      }
    });

    this.chargecode.rate = rate;
  }


  addUserToChargeCode(user) {
    this.chargecode.users.push(user);

    _.remove(this.activeUsers, function (u) {
        return u.id == user.id;
    });

    this.selectedUser = undefined;
  }

  removeUserFromChargeCode(user) {
    _.remove(this.chargecode.users, function (u) {
      return u.id == user.id;
    });

    this.activeUsers.push(user);
  }


  chargeCodeValid() {
    let hasName = this.chargecode.name && this.chargecode.name.length > 0 && this.codeExists == false;
    return hasName;
  }

  checkForExistingChargeCodeName() {
    let self = this;
    if(this.chargecode.name.length == 0){
      this.codeExists = undefined;
      return;
    }

    if(this.chargecode.name && this.chargecode.name.length > 0) {
      this.$http.get(self.$rootScope.apiHost + '/api/admin/chargecodes/name/' + this.chargecode.name, {withCredentials: true}).then(function (success) {
        self.codeExists = true;
      }, function (failure) {
        self.codeExists = false;
      });
    };

  }

  initializeData() {
    let self = this;
    this.chargecode = [];
    this.customers = [];
    this.customerFilter = 'none';
    this.contractFilter = 'none';
    this.taskFilter = 'none';
    this.lcatFilter = 'none';
    this.popFilter = 'none';
    this.codeExists = undefined;
    this.step = 0

    this.$http.get(this.$rootScope.apiHost+"/api/admin/customers", {withCredentials: true}).then(function (success) {
      self.customers = success.data;
      self.chargecode = {
        leaveType : 'false',
        users: []
      };

      self.$http.get(self.$rootScope.apiHost+"/api/leave/types", {withCredentials: true}).then(function (success) {
        self.leaveTypes = success.data;
        self.chargecode.associatedLeaveType = 'none';
      });
    });



    this.$http.get(self.$rootScope.apiHost+'/api/admin/users/?active=true', {withCredentials: true}).then(function (success) {
      self.activeUsers = success.data;
    });

  }


  createChargeCode() {
    let self = this;

    let userIds = [];

    this.chargecode.users.forEach(function (user) {
      userIds.push(user.id);
    });

    this.chargecode.users = userIds;

    if(this.chargecode.associatedLeaveType) {
      this.chargecode.associatedLeaveType = this.chargecode.associatedLeaveType.id;
    }

    this.$http.post(self.$rootScope.apiHost + '/api/admin/chargecodes', this.chargecode, {withCredentials: true}).then(function (success) {
      self.toastr.success("Charge Code Created", "Charge Code Created Succesfully!");
      self.state.go("admin.chargecode-details", {'chargecodeId': success.data.id});
    }, function (failure) {
      self.toastr.error("Problem Creating Charge Code", "ERROR!")
    });

  }




}

export default ExpenseWizardController;



// WEBPACK FOOTER //
// ./client/pages/expenses/expense-wizard/expense-wizard.controller.js